export enum MeritBudgetWorkflowType {
  AllocationByInCompanyManagerInvisibleForLineManager = 'AllocationByInCompanyManagerInvisibleForLineManager',
  AllocationByInCompanyManagerVisibleForLineManager = 'AllocationByInCompanyManagerVisibleForLineManager',
  AllocationByLineManagerVisibleForInCompanyManager = 'AllocationByLineManagerVisibleForInCompanyManager',
  AllocationByLineManagerApprovalByInCompanyManager = 'AllocationByLineManagerApprovalByInCompanyManager'
}
